import { call, delay, put, takeLatest } from 'redux-saga/effects'
import { routerReducers } from './RouterSlice'
import { routerActions } from './RouterActions'
import { getPlatformType, getStripeMode } from './Utils'
import { userActions } from 'redux/user/userSlice'

export function* updateConnectedAccountSaga() {
  const platformType = getPlatformType()
  const { mode, connectedAccount } = yield call(getStripeMode, platformType)
  yield put(routerReducers.setConnectedAccount({ mode, connectedAccount }))
}

export function* routerSaga() {
  yield takeLatest(
    [routerActions.updateConnectedAccount.type],
    updateConnectedAccountSaga
  )
  // Calling updateConnectedAccountSaga when the user logs in successfully
  yield takeLatest([userActions.loginSuccess.type], updateConnectedAccountSaga)
  yield takeLatest(
    [userActions.socialLoginSuccess.type],
    updateConnectedAccountSaga
  )
  yield takeLatest(
    [userActions.ssoLoginSuccess.type],
    updateConnectedAccountSaga
  )
}

export default routerSaga
